import type { FormEvent } from 'react';
import { useState } from 'react';
import { useTracking } from 'react-tracking';

import { Modal, Textfield } from '@simplywallst/ui-core';

import useWatchlistMutations from '../../hooks/useWatchlistMutations';

interface Props {
  onClose: () => void;
  onCreate?: () => void;
}

const isWatchlistNameValid = (name: string) => {
  return name.length > 0;
};

const CreateWatchlistModal = ({ onClose, onCreate }: Props) => {
  const { trackEvent } = useTracking();
  const { createWatchlist } = useWatchlistMutations();

  const [watchlistName, setNewWatchlistName] = useState('');
  const [nameLengthError, setNameLengthError] = useState(false);

  const handleCreate = () => {
    trackEvent({
      action: 'click',
      modifier: 'createWatchlist',
    });
    createWatchlist({
      name: watchlistName,
    });
    onCreate && onCreate();
  };

  return (
    <Modal
      title="Create List"
      asForm={true}
      onSecondaryClick={onClose}
      onPrimaryClick={handleCreate}
      secondaryLabel="Cancel"
      primaryLabel="Create List"
      primaryDisabled={!isWatchlistNameValid(watchlistName)}
    >
      <Textfield
        name="listName"
        styleType="standardReverse"
        type="text"
        label="List Name"
        placeholder='e.g. "Tech Stocks"'
        value={watchlistName}
        onChange={(e: FormEvent<HTMLInputElement>) => {
          setNewWatchlistName(e.currentTarget.value);
          setNameLengthError(!isWatchlistNameValid(e.currentTarget.value));
        }}
        error={nameLengthError ? 'Name cannot be blank' : ''}
      />
    </Modal>
  );
};

export default CreateWatchlistModal;
